// frontend/src/components/flight/FlightCard.jsx
import React from 'react';

const FlightCard = ({ flight, onSelect }) => {
  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}m`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="flight-card">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div className="flex-1 w-full md:w-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
              <span className="font-bold text-lg">{flight.airline_code}</span>
              <span className="text-gray-600">{flight.flight_number}</span>
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold text-blue-600">
                ${flight.base_price}
              </div>
              <div className="text-sm text-gray-500">per person</div>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-8">
              {/* Departure */}
              <div className="text-center">
                <div className="text-2xl font-bold">{formatTime(flight.departure_time)}</div>
                <div className="text-sm text-gray-600">{flight.origin_airport}</div>
                <div className="text-xs text-gray-500">{formatDate(flight.departure_time)}</div>
              </div>

              {/* Flight Path */}
              <div className="flex-1 flex items-center justify-center px-4">
                <div className="text-center">
                  <div className="text-sm text-gray-500 mb-1">
                    {formatDuration(flight.duration)}
                  </div>
                  <div className="flex items-center">
                    <div className="w-3 h-3 border-2 border-blue-600 rounded-full"></div>
                    <div className="flex-1 h-px bg-blue-600 mx-2 relative">
                      {flight.stops > 0 && (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                        </div>
                      )}
                    </div>
                    <div className="w-3 h-3 border-2 border-blue-600 rounded-full bg-blue-600"></div>
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    {flight.stops === 0 ? 'Direct' : `${flight.stops} stop${flight.stops > 1 ? 's' : ''}`}
                  </div>
                </div>
              </div>

              {/* Arrival */}
              <div className="text-center">
                <div className="text-2xl font-bold">{formatTime(flight.arrival_time)}</div>
                <div className="text-sm text-gray-600">{flight.destination_airport}</div>
                <div className="text-xs text-gray-500">{formatDate(flight.arrival_time)}</div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200">
            <div className="flex items-center space-x-4 text-sm text-gray-600">
              <span>{flight.airline_name}</span>
              <span>•</span>
              <span>{flight.aircraft_type}</span>
              <span>•</span>
              <span>{flight.available_seats} seats left</span>
            </div>
            <button
              onClick={onSelect}
              className="btn btn-primary px-6 py-2"
            >
              Select Flight
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightCard;